const sortOptionsLabels: Record<string, string> = {
  'sort:created-desc': 'Newest',
  'sort:created-asc': 'Oldest',
  'sort:comments-desc': 'Most commented',
  'sort:updated-desc': 'Recently updated',
  'sort:reactions-+1-desc': 'Thumbs up',
  'sort:reactions--1-desc': 'Thumbs down',
  'sort:reactions-rocket-desc': 'Rocket',
  'sort:reactions-tada-desc': 'Hooray',
  'sort:reactions-eyes-desc': 'Eyes',
  'sort:reactions-heart-desc': 'Heart',
}

export const LABELS = {
  sort: 'Sort',
  Newest: 'Newest',
  Oldest: 'Oldest',
  RecentlyUpdated: 'Recently updated',
  sortingLabels: sortOptionsLabels,
  sortBy: 'Sort by',
  sortByReactions: 'Sort by reactions',
  mostReactions: 'Most reactions',
  Default: 'Default',
  Compact: 'Compact',
  Density: 'Density',
  noResultsTitle: 'No results',
  noResultsDescription: 'Try adjusting your search filters.',
  mostCommented: 'Most commented',
  thumbsUp: '👍 Thumbs up',
  thumbsDown: '👎 Thumbs down',
  rocket: '🚀 Rocket',
  hooray: '🎉 Hooray',
  eyes: '👀 Eyes',
  heart: '❤️ Heart',
}
